import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';

declare let gtag: any;

@Injectable()
export class GoogleAnalyticsService {

  constructor() {}

  private isEnabled(): boolean {
    if (typeof gtag !== 'undefined') {
      return true;
    }
    return false;
  }

  public sendPageView(): void {
    if (!this.isEnabled()) {
      return;
    }

    gtag('config', environment.analytics.id, {
      'page_path': location.pathname
    });
  }

  public sendLinkClickEvent(eventName: string, eventLabel: any): void {
    if (!this.isEnabled()) {
      return;
    }

    gtag('event', eventName, {
      event_category: 'link',
      event_action: 'click',
      event_label: eventLabel
    });
  }

  public sendMp3DownloadClickEvent(eventName: string, eventLabel: any): void {
    if (!this.isEnabled()) {
      return;
    }

    gtag('event', eventName, {
      event_category: 'mp3',
      event_action: 'download',
      event_label: eventLabel
    });
  }

  public sendMp3PlayerClickEvent(eventName: string, eventLabel: any): void {
    if (!this.isEnabled()) {
      return;
    }

    gtag('event', eventName, {
      event_category: 'mp3',
      event_action: 'play',
      event_label: eventLabel
    });
  }
}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/service/utils/google-analytics.service.ts